import * as React from "react"
import styled from "@digits-css"
import { useLogOutMutation } from "@digits-graphql/admin/graphql-public"
import { SvgDigitsLogo } from "@digits-shared/components/SVGIcons/digits/DigitsLogo.svg"
import { CenteredDialogContainer } from "@digits-shared/components/UI/Elements/Container"
import { DigitsButton } from "@digits-shared/DesignSystem/Button"
import useConstant from "@digits-shared/hooks/useConstant"
import useSession from "@digits-shared/hooks/useSession"
import { Theme } from "@digits-shared/themes"
import colors from "@digits-shared/themes/colors"
// eslint-disable-next-line no-restricted-imports -- TODO: migrate to digits-css
import { ThemeContext } from "styled-components"
import type AdminSession from "src/admin/session/AdminSession"
import "./LogOut.digits.css"

/*
  STYLES
*/

const LogOutStyled = styled.div({ cls: "LogOut__LogOutStyled_adb62df" })

const LogOutContainer = styled(CenteredDialogContainer)({ cls: "LogOut__LogOutContainer_03238ea" })

const Logo = styled(SvgDigitsLogo)({ cls: "LogOut__Logo_fbc8952" })

const H2Styled = styled.div({ cls: "LogOut__H2Styled_b7976d1" })

/*
  COMPONENTS
*/

const LogOut: React.FC = () => {
  const session = useSession<AdminSession>()

  const onSuccessfulLogOut = React.useCallback(async () => {
    await session.clear()
  }, [session])

  const [logOut] = useLogOutMutation({
    onCompleted: onSuccessfulLogOut,
    context: { publicAPI: true },
  })

  const onClick = React.useCallback(() => logOut(), [logOut])
  const theme = useConstant({ mode: Theme.Dark })
  return (
    <ThemeContext.Provider value={theme}>
      <LogOutStyled>
        <LogOutContainer>
          <Logo />
          <H2Styled>Are you sure you want to sign out?</H2Styled>
          <DigitsButton width={360} onClick={onClick}>
            Sign Out
          </DigitsButton>
        </LogOutContainer>
      </LogOutStyled>
    </ThemeContext.Provider>
  )
}
export default LogOut
